import React, { useEffect, useRef, useState } from "react";
import Loader from "../../../../../components/loader/loader";
import Snackbar from "../../../../../components/snackbar/snackbar";
import { create_vendors } from "../../../user.api";
import jwtDecode from "jwt-decode";
import {
  builtup,
  euip,
  jointVenture,
  landon,
  ownland,
} from "./components/areadata";

import BasicDetails from "./components/basicDetails";
import View from "./components/viewDetails";
import "./style.css";
import moment from "moment";

export default function NewCompanyRequest(props) {
  const [activeStep, setActiveStep] = useState(0);
  
  // Check if user is a company user (userType === 4) and get their phone number
  const getCompanyUserPhone = () => {
    const token = props?.state?.payload || localStorage.getItem("token") || sessionStorage.getItem("token");
    if (!token) return props.phone; // fallback to props.phone
    
    try {
      const decoded = jwtDecode(token);
      const userType = decoded.user?.user_type;
      
      // If user is a company user (userType === 4), use their phone number
      if (userType === 4) {
        return decoded.user?.mobile_number || decoded.user?.phone || props.phone;
      }
      
      return props.phone; // fallback for other users
    } catch (error) {
      return props.phone; // fallback on error
    }
  };

  const [basicData, setBasicData] = useState({
    phone_number: getCompanyUserPhone(),
    alternate_email: props.alternate_email,
  });

  const [addCount, setCount] = useState(1);
  const myRef = useRef(null);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [areamange, setareaManage] = useState(builtup);
  // const getDomainTypes = () => {
  //   user_company_domain_list().then((res) => {
  //     setDomain(res.data);
  //     setCount(addCount + 1);
  //   });
  // };
  const action = (id, data, key) => {
    myRef.current.scrollIntoView();
    if (id === 0) {
      setActiveStep(1);
      setBasicData({ ...data });
    } else if (id === 1) {
      setActiveStep(0);
    } else if (id === 2) {
      handleSubmit();
    }
  };
  const fetchError = (error) => {
    let errmsg = "";
    let errArry = [];
    const errData = error?.response?.data;

    if (errData) {
      if (errData.message) {
        errmsg = errData.message;
      } else if (errData.error) {
        Object.keys(errData.error).forEach((key) => {
          let err = String(errData.error[key]);
          errArry.push(err);
        });
        errmsg = errArry.join(", ");
      }
    } else {
      errmsg = error?.message || "Something went wrong!";
    }

    return errmsg;
  };
  const handleSubmit = () => {
    let areatype = [];
    if (basicData.area_management) {
      basicData?.area_management?.forEach((item, index) => {
        if (item.location_id) {
          areatype[index] = item;
        }
      });
    }
    const form = new FormData();

    form.append("name", basicData.name ?? null);
    form.append("email", basicData.email);
    basicData.alternate_email &&
      form.append("alternate_email", basicData.alternate_email);
    form.append("phone", basicData.phone_number ?? null);
    if (basicData?.alternate_phone) {
      form.append("alternate_phone", basicData?.alternate_phone ?? "");
    }
    if (basicData?.alt_country_code) {
      form.append("alt_country_code", basicData?.alt_country_code ?? "");
    }

    form.append("company_name", basicData.company_name ?? null);
    form.append("address", basicData.address ?? null);
    form.append("area_of_operation", basicData.area_of_operation ?? "");
    form.append("company_description", basicData.company_description ?? "");
    form.append("logo", basicData.logo ?? "");
    form.append("logo_name", basicData.logo_name ?? "");
    form.append("brochure_name", basicData.brochure_name ?? "");

    form.append("brochure", basicData.brochure ?? "");

    setIsActive(true);
    create_vendors(form)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setIsActive(false);
        setSnackOpen(true);
      })
      .catch((error) => {
        console.log(error?.response?.data?.message);
        setSnackMessage(fetchError(error));
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };
  const headlperText = {
    header: "",
  };

  // useEffect(() => {
  //   if (domainData.length === 0) {
  //     getDomainTypes();
  //   }
  //   // handleChangedata("3");
  // }, []);

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      props.logout();
    }
  };

  return (
    <div className="page-bg" ref={myRef}>
      <Loader open={isActive} />
      <div>
        <div className="dash-banner ">
          <div className="tit-txt">Vendor Registration</div>
        </div>
      </div>
      <div className="formbg form-bg">
        <div className="container form-section">
          <div className="itemc">
            <div className="fomy form-inner-section">
              {activeStep === 0 && (
                <BasicDetails {...props} action={action} formData={basicData} />
              )}

              {activeStep === 1 && (
                <View {...props} basicData={basicData} action={action} />
              )}
            </div>
            <Snackbar
              message={snackMessage}
              error={isSnackError}
              open={snackOpen}
              close={snackbarClose}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
